import type express from 'express';
import type { Options as ProxyOptions } from 'http-proxy-middleware';

type McProxy = { path: string | string[]; options: ProxyOptions };

export const services = {
  // global.mccompass.internal_url
  mcCompass: process.env.MCCOMPASS_INTERNAL_URL || 'https://mccompass-develop.mcmakler.com',

  // global.mcm_assets_service.internal_url
  assets:
    process.env.MCM_ASSETS_SERVICE_INTERNAL_URL ||
    'https://mcm-assets-service-develop.mcmakler.com',

  // global.mcsearch.external_url
  mcSearch: process.env.MCSEARCH_EXTERNAL_URL || 'https://mcsearch-master.mcmakler.com',

  // global.pdf_service.internal_url
  mcmPdf: process.env.PDF_SERVICE_INTERNAL_URL || 'https://pdf-service-develop.mcmakler.com',

  // global.email_gateway.internal_url
  emailGateway:
    process.env.EMAIL_GATEWAY_INTERNAL_URL || 'https://email-gateway-develop.mcmakler.com',

  // global.feedback_management.internal_url
  feedback:
    process.env.FEEDBACK_MANAGEMENT_INTERNAL_URL ||
    'https://feedback-management-develop.mcmakler.com',

  // global.aws_v2.pdf_s3_cloudfront
  awsPdf: process.env.AWS_PDF_S3_CLOUDFRONT || 'https://pdf-staging.mcmakler.com',

  smartRecruiters:
    'https://www.smartrecruiters.com/job-api/public/search/widgets/McMakler1/postings?&offset=0&limit=1000&jobAdType=PUBLIC&fq=&customFields=&langCode=en&_=1590152790404',

  // global.leadgen_widget.external_url
  leadgenWidget:
    process.env.LEADGEN_WIDGET_EXTERNAL_URL || 'https://leadgen-widget-develop.mcmakler.com',

  // global.partner_api.internal_url
  partnerApi:
    process.env.PARTNER_API_INTERNAL_URL || 'https://partner-page-backend-develop.mcmakler.com',

  // global.appointment.internal_url
  appointment: process.env.APPOINTMENT_INTERNAL_URL || 'https://appointment-develop.mcmakler.com',

  // global.mcm_application_service.internal_url
  mcmApplication:
    process.env.MCM_APPLICATION_SERVICE_INTERNAL_URL ||
    'https://mcm-application-service-develop.mcmakler.com',

  // widget_lite_service.internal_url
  widgetLite:
    (process.env.WIDGET_LITE_SERVICE_INTERNAL_URL ||
      'https://widget-lite-service-develop.mcmakler.com') + '/api',

  // global.geo_service.internal_url
  geo: process.env.GEO_SERVICE_INTERNAL_URL || 'https://geo-service-develop.mcmakler.com',

  // global.graphql_gateway.internal_url
  graphqlGateway:
    process.env.GRAPHQL_GATEWAY_INTERNAL_URL || 'https://graphql-gateway-master.mcmakler.com',

  // global.mccompass_service.internal_url
  mcCompassApi:
    process.env.MCCOMPASS_SERVICE_INTERNAL_URL || 'https://mccompass-service-master.mcmakler.com',

  // global.mcql.internal_url
  mcql: process.env.MCQL_INTERNAL_URL || 'https://mcql-develop.mcmakler.com',

  // global.id.internal_url
  id: process.env.ID_INTERNAL_URL || 'https://id-develop.mcmakler.com',

  // global.recommendation_management.internal_url
  recommendationManagement:
    process.env.RECOMMENDATION_MANAGEMENT_INTERNAL_URL ||
    'https://mcmakler-recommendation-management-develop.mcmakler.com',

  // suggest_timeslots.internal_url
  suggestTimeslots:
    process.env.SUGGEST_TIMESLOTS_INTERNAL_URL || 'https://suggest-timeslots-develop.mcmakler.com',

  // TODO: move to env variables, publicRuntimeConfig
  widgetApp: 'https://widget.mcmakler.de',
  webApp: 'https://www.mcmakler.de',
};

const apiRedirects: [string, string][] = [
  ['/api-assets', services.assets],
  ['/api-mcm-pdf-service', services.mcmPdf],
  ['/api-email-gateway', services.emailGateway],
  ['/api-feedback', services.feedback],
  ['/api-pdf', services.awsPdf],
  ['/api-smart-recruiters', services.smartRecruiters],
  ['/api-partner', services.leadgenWidget],
  ['/api-press', services.partnerApi],
  ['/api-appointment', services.appointment],
  ['/api-application', services.mcmApplication],
  ['/api-widget', services.widgetLite],
  ['/api-timeslots', services.suggestTimeslots],
  ['/api/places', services.graphqlGateway],
  ['/api-geo', services.geo],
  [
    '/api-mccompass/storyblok-webhook',
    services.mcCompassApi + '/api/storyblok/webhook-update-location-text',
  ],
  ['/api-mccompass', services.mcCompassApi + '/graphql'],
  ['/api-broker-recruitment', services.leadgenWidget],
  ['/api-gql', services.mcql],
  ['/api-googleplaces', 'https://maps.googleapis.com/maps/api/place/autocomplete/json'],
  ['/api-googlegeocode', 'https://maps.googleapis.com/maps/api/geocode/json'],
  ['/api-id', services.id],
  ['/api-search-profile', services.recommendationManagement],
];

export const apiProxies = createProxies(apiRedirects);

export const proxies = createProxies([
  ['/immobilienpreise', `${services.mcCompass}/immobilienpreise`],
  ['/immobilien', `${services.mcSearch}/immobilien`],
  ...apiRedirects,
]);

function createProxies(redirets: [string, string][]): McProxy[] {
  return redirets.map(([apiName, target]) => {
    return {
      path: apiName,
      options: {
        target,
        changeOrigin: true,
        pathRewrite: { [apiName]: '' },
        onProxyRes: apiName.startsWith('/api')
          ? function (proxyRes, _req: express.Request, _res: express.Response) {
              proxyRes.headers['Access-Control-Allow-Origin'] = '*';
              proxyRes.headers['Access-Control-Allow-Headers'] = '*';
              proxyRes.headers['Access-Control-Allow-Methods'] = '*';
              proxyRes.headers['Access-Control-Expose-Headers'] = 'Content-Length,Content-Range';
            }
          : undefined,
      },
    };
  });
}
